// extracted by mini-css-extract-plugin
export default {"container":"NumberInput_container__1xxVa","button":"NumberInput_button__Yq83h","input":"NumberInput_input__9tM7S"};